<template>
  <main>
    <section
      id="podcast-section"
      class="relative bg-cover bg-center"
      style="background-image: url(&quot;/img/meditations-bg.webp&quot;)"
    >
      <!-- Dark overlay for better text visibility -->
      <div class="absolute inset-0 bg-black bg-opacity-30"></div>
      <div class="relative z-10 mx-auto px-4 sm:px-0 pt-20 sm:pt-32 pb-20 max-w-5xl">
        <h2 class="text-2xl sm:text-3xl font-bold text-center text-white">
          All Guided Meditations
        </h2>

        <div
          class="flex flex-col md:flex-row gap-4 mx-auto mt-4 p-2 rounded-lg sm:max-h-[70vh]"
        >
          <!-- Main player -->
          <div class="flex flex-col w-full sm:w-1/2">
            <PodcastCardFull
              v-if="currentAudio"
              :audio="currentAudio"
              :audioSrc="currentAudio.file_url"
            />
            <div v-else class="text-center text-white py-20">
              No meditations available to play.
            </div>
          </div>

          <!-- List of meditations -->
          <div
            class="w-full sm:w-1/2  space-y-4 overflow-y-auto p-2 custom-scrollbar"
          >
            <div v-if="audios && audios.data.length > 0">
              <PodcastCardThumb
                @click="changeAudio(audio)"
                v-for="audio in audios.data"
                :key="audio.id"
                :audio="audio"
                class="cursor-pointer"
              />
            </div>
            <div v-else class="text-center text-gray-500 py-10">
              Loading meditations...
            </div>

            <!-- <div class="flex justify-center items-center gap-4 mt-6 text-white">
              <button
                @click="changePage(currentPage - 1)"
                :disabled="currentPage === 1"
                class="px-4 py-2 rounded-md bg-brand disabled:opacity-50"
              >
                Previous
              </button>
              <span>Page {{ currentPage }} of {{ totalPages }}</span>
              <button
                @click="changePage(currentPage + 1)"
                :disabled="currentPage >= totalPages"
                class="px-4 py-2 rounded-md bg-brand disabled:opacity-50"
              >
                Next
              </button>
            </div> -->
          </div>
        </div>

        <div class="hidden justify-center mt-10">
          <NuxtLink
            to="/"
            class="flex items-center gap-2 bg-brand border border-white text-white font-semibold py-3 px-6 rounded-md shadow-md hover:bg-brand-light transition-colors duration-300"
          >
            Back to Home
          </NuxtLink>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import type { Tables } from "../types/database.types";

import PodcastCardThumb from "~/components/PodcastCardThumb.vue";
import PodcastCardFull from "~/components/PodcastCardFull.vue";
// Pass null to remove the limit and get all available podcasts
const limit = 0;
const currentPage = ref(1);
const totalPages = ref(0);

const supabase = useSupabaseClient();
const { data: audios } = await useFetchAudios(limit);

const currentAudio = ref<Tables<"audios">>({} as Tables<"audios">);

if (audios.value && audios.value.data.length > 0) {
  currentAudio.value = audios.value.data[0];
  currentPage.value = audios.value.pagination.page;
  totalPages.value = audios.value.pagination.totalPages;
} else {
  currentAudio.value = {} as Tables<"audios">;
}

definePageMeta({
  layout: "default"
});

const changeAudio = (audio) => {
  console.log("Audio changed");
  currentAudio.value = audio;
};

const changePage = async (page: number) => {
  if (page < 1 || page > totalPages.value) return;
  currentPage.value = page;

  const url = `/api/audios?limit=${limit}&page=${page}`;
  const { data, error } = await useFetch(url, {
    headers: useRequestHeaders(["cookie"])
  });

  if (error.value) {
    throw createError({
      ...error.value,
      statusMessage: "Unable to fetch audio"
    });
  }

  audios.value = data.value;
  window.scrollTo({ top: 0, behavior: "smooth" });
};
</script>

<style>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* For Firefox */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);
}
</style>
